import EventDetailsContent from './EventDetailsContent';

export default EventDetailsContent;
